import React, { Component, useEffect, useState } from 'react';

import ApiUrls from '../../../services/apiUrls';
import CommonService from '../../../services/commonService';
import { KuposModalWithButtons } from '../../common';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const gender = [
  { value: 'male', label: 'HOME.MALE' },
  { value: 'female', label: 'HOME.FEMALE' },
];

function LoggedInCard(props) {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [ftmPoints, setFtmPoints] = useState(null)
  const { profileData, t } = props;

  useEffect(() => {
    if (profileData && profileData.identity_type)
      getFTMPoints(profileData.identity_val)
  }, [])

  const getGender = g => {
    let genVal = gender.find(it => it.value == g);
    return genVal ? props.t(genVal.label) : '';
  };

  const logoutUser = () => {
    try {
      let googleAccessToken = localStorage.getItem('googleAccessToken');
      if (googleAccessToken)
        props.actions.googleLogout({ url: ApiUrls.googleLogout(googleAccessToken) });
      window.FB.logout();
    } catch (e) {
      console.log(e);
    }
    // this.setState({ showLogoutModal: false });
    setShowLogoutModal(false);
    CommonService.logout();
    props.history.push('/');
  };

  const getFTMPoints = (rut) => {
    props.apiCall({
      url: ApiUrls.createUrl('api/services/get_customer_ftm_points_list?rut=' + rut),
      method: 'GET',
      type: "home"
    })
    .then(res => {
      console.log({ res })
      if (res && res.data && res.data.data && res.data.data.status == 200) {
        let keys = Object.keys(res.data.data).filter(key => key != 'status')
        setFtmPoints(res.data.data[keys[0]])
      } else {
        setFtmPoints(null);
      }
      
    });
  }


  return (
    <div className="kupos-card logged-in-card kupos-card-padding-l">
      <div className="logged-in-name font20">
        {t('PROFILE.HELLO')}
        <span className="bold-text bold-text text-capitalize">
          &nbsp;{profileData && profileData.name}!
        </span>
      </div>

      <div className="display-flex logged-in-options-edit-logout">
        <div onClick={() => props.onProfileEdit(true)}>
          <img src="/images/edit_profile.svg" />
        </div>
        <a onClick={() => setShowLogoutModal(true)}>
          <img src="/images/log_out.svg" />
        </a>
      </div>

      <div className="name-and-image">
        <div className="user-image">
          {profileData && profileData.image_link ? (
            <div className="dp-image-my-account">
              <img src={profileData.image_link} alt="DIS" />
            </div>
          ) : (
            <div className="dp-image-my-account">
              <img src="/images/icons/home/icon-user-circle.png" alt="" />
            </div>
          )}
        </div>
        <div className="user-name-and-email">
          <div className="font13 bold-text">
            {profileData.name} {profileData.last_name}
          </div>
          <span className="font10">{profileData.email}</span>
        </div>
      </div>

      <div className="logged-in-personal-details font10">
        <div className="ind-detail">
          <span className=" bold-text">{t('PASSENGER_DETAILS.PHONE_NUMBER')} </span>
          <span className="text-end">
            {profileData && profileData.phone ? profileData.phone : props.t('HOME.TO_BE_ADDED')}
          </span>
        </div>
        <div className="ind-detail">
          <span className=" bold-text">{t('PASSENGER_DETAILS.RUT_PASSPORT_DNI')}</span>
          <span className="text-end">
            {profileData && profileData.identity_val
              ? profileData.identity_type == 7
                ? CommonService.formatRut(profileData.identity_val)
                : profileData.identity_val
              : props.t('HOME.TO_BE_ADDED')}
          </span>
        </div>
        <div className="ind-detail">
          <span className=" bold-text">{t('PROFILE.GENDER')} </span>
          <span
            className={'text-end ' + (profileData && profileData.gender ? '' : 'pointer')}
            onClick={() => (profileData && profileData.gender ? null : props.onProfileEdit(true))}
          >
            {profileData.gender ? getGender(profileData.gender) : props.t('HOME.TO_BE_ADDED')}
          </span>
        </div>
      </div>

      <hr className="horizontal-line" />

      <div className="final-ind-detail font11 bold-text">
        {t('PROFILE.AVAILABLE_BALANCE')}
        <span className="text-end bold-text">
          CLP{' '}
          {profileData &&
            profileData.wallet_moneys &&
            profileData.wallet_moneys[0].amount.split(' ').join('')}
        </span>
      </div>
      {(ftmPoints || ftmPoints === 0) && <div className="final-ind-detail font11 bold-text" style={{marginTop: -3}}>
        Puntos FTM
        <span className="text-end bold-text">
          {ftmPoints}
        </span>
      </div>}

      <KuposModalWithButtons
        onHide={() => {
          // this.setState({ showLogoutModal: false });
          setShowLogoutModal(false);
        }}
        showModal={showLogoutModal}
        title={t('PROFILE.LOGOUT_SURE')}
        showButton1={true}
        buttonText1={t('PROFILE.YES_LOGOUT')}
        onButtonClick1={logoutUser}
        showButton2={true}
        buttonText2={t('PROFILE.NO_LOGOUT')}
        onButtonClick2={() => {
          // this.setState({ showLogoutModal: false });
          setShowLogoutModal(false);
        }}
      />
    </div>
  );
}

export default LoggedInCard;

// export default class LoggedInCard extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       showLogoutModal: false,
//     };
//   }

//   static propTypes = {
//     actions: PropTypes.object,
//     onProfileEdit: PropTypes.func,
//     profileData: PropTypes.object,
//     t: PropTypes.func,
//     history: PropTypes.object,
//   };

//   getGender = g => {
//     let genVal = gender.find(it => it.value == g);
//     return genVal ? this.props.t(genVal.label) : '';
//   };

//   logoutUser = () => {
//     try {
//       let googleAccessToken = localStorage.getItem('googleAccessToken');
//       if (googleAccessToken)
//         this.props.actions.googleLogout({ url: ApiUrls.googleLogout(googleAccessToken) });
//       window.FB.logout();
//     } catch (e) {
//       console.log(e);
//     }
//     this.setState({ showLogoutModal: false });
//     CommonService.logout();
//     this.props.history.push('/');
//   };

//   render() {
//     const { profileData, t } = this.props;
//     return (
//       <div className="kupos-card logged-in-card kupos-card-padding-l">
//         <div className="logged-in-name font20">
//           {t('PROFILE.HELLO')}
//           <span className="bold-text bold-text text-capitalize">
//             &nbsp;{profileData && profileData.name}!
//           </span>
//         </div>

//         <div className="display-flex logged-in-options-edit-logout">
//           <div onClick={() => this.props.onProfileEdit(true)}>
//             <img src="/images/edit_profile.svg" />
//           </div>
//           <a onClick={() => this.setState({ showLogoutModal: true })}>
//             <img src="/images/log_out.svg" />
//           </a>
//           {/* <div onClick={() => this.logoutUser()}>
//             <img src="/images/log_out.svg" />
//           </div> */}
//         </div>

//         {/* <div className="logged-in-capsule-menu" onClick={() => this.props.onProfileEdit(true)}>
//           <span className="font10 bold-text">{t('PROFILE.EDIT')}</span>
//         </div> */}

//         <div className="name-and-image">
//           <div className="user-image">
//             {profileData && profileData.image_link ? (
//               <div className="dp-image-my-account">
//                 <img src={profileData.image_link} alt="DIS" />
//               </div>
//             ) : (
//               <div className="dp-image-my-account">
//                 <img src="/images/icons/home/icon-user-circle.png" alt="" />
//               </div>
//             )}
//           </div>
//           <div className="user-name-and-email">
//             <div className="font13 bold-text">
//               {profileData.name} {profileData.last_name}
//             </div>
//             <span className="font10">{profileData.email}</span>
//           </div>
//         </div>

//         <div className="logged-in-personal-details font10">
//           <div className="ind-detail">
//             <span className=" bold-text">{t('PASSENGER_DETAILS.PHONE_NUMBER')} </span>
//             <span className="text-end">
//               {profileData && profileData.phone
//                 ? profileData.phone
//                 : this.props.t('HOME.TO_BE_ADDED')}
//             </span>
//           </div>
//           <div className="ind-detail">
//             <span className=" bold-text">{t('PASSENGER_DETAILS.RUT_PASSPORT_DNI')}</span>
//             <span className="text-end">
//               {profileData && profileData.identity_val
//                 ? profileData.identity_type == 7
//                   ? CommonService.formatRut(profileData.identity_val)
//                   : profileData.identity_val
//                 : this.props.t('HOME.TO_BE_ADDED')}
//             </span>
//           </div>
//           <div className="ind-detail">
//             <span className=" bold-text">{t('PROFILE.GENDER')} </span>
//             <span
//               className={'text-end ' + (profileData && profileData.gender ? '' : 'pointer')}
//               onClick={() =>
//                 profileData && profileData.gender ? null : this.props.onProfileEdit(true)
//               }
//             >
//               {profileData.gender
//                 ? this.getGender(profileData.gender)
//                 : this.props.t('HOME.TO_BE_ADDED')}
//             </span>
//           </div>
//         </div>

//         <hr className="horizontal-line" />

//         <div className="final-ind-detail font11 bold-text">
//           {t('PROFILE.AVAILABLE_BALANCE')}
//           <span className="text-end bold-text">
//             CLP{' '}
//             {profileData &&
//               profileData.wallet_moneys &&
//               profileData.wallet_moneys[0].amount.split(' ').join('')}
//           </span>
//         </div>

//         <KuposModalWithButtons
//           onHide={() => {
//             this.setState({ showLogoutModal: false });
//           }}
//           showModal={this.state.showLogoutModal}
//           title={t('PROFILE.LOGOUT_SURE')}
//           showButton1={true}
//           buttonText1={t('PROFILE.YES_LOGOUT')}
//           onButtonClick1={this.logoutUser}
//           showButton2={true}
//           buttonText2={t('PROFILE.NO_LOGOUT')}
//           onButtonClick2={() => {
//             this.setState({ showLogoutModal: false });
//           }}
//         />
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/features/my-account/LoggedInCard/LoggedInCard.js